import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FileXls, EnvelopeSimple } from '@phosphor-icons/react';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = (extra = {}) => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, ...extra });

export const AuditReportsCard = () => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState('');
  const load = useCallback(() => {
    axios.get(`${API}/admin/audit-reports`, cfg()).then((r) => setRows(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const download = async (r) => {
    setBusy(r.report_id);
    try {
      const res = await axios.get(`${API}/admin/audit-reports/${r.report_id}/download`, cfg({ responseType: 'blob' }));
      const a = document.createElement('a'); a.href = URL.createObjectURL(res.data); a.download = r.filename; a.click();
    } catch (e) { toast.error('Αποτυχία λήψης'); } finally { setBusy(''); }
  };
  const email = async (r) => {
    const to = window.prompt('Αποστολή σε email:', 'micbuildings@gmail.com');
    if (!to) return;
    setBusy(r.report_id);
    try {
      await axios.post(`${API}/admin/audit-reports/${r.report_id}/email`, { to }, cfg());
      toast.success(`Στάλθηκε στο ${to}`); load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Αποτυχία αποστολής'); } finally { setBusy(''); }
  };

  return (
    <div className="border border-zinc-200 bg-white p-4 mb-6" data-testid="audit-reports-card">
      <h2 className="text-sm font-bold mb-1 flex items-center gap-2"><FileXls size={16} /> Αναφορές Ελέγχου Δεδομένων</h2>
      <p className="text-xs text-zinc-500 mb-3">Αναφορές μόνο για έλεγχο — καμία εγγραφή δεν διαγράφεται από εδώ.</p>
      {rows.length === 0 && <p className="text-xs text-zinc-400" data-testid="audit-reports-empty">Δεν υπάρχουν αναφορές.</p>}
      <div className="divide-y divide-zinc-100">
        {rows.map((r) => (
          <div key={r.report_id} className="flex items-center gap-3 py-2 text-sm" data-testid={`audit-report-${r.report_id}`}>
            <div className="flex-1">
              <p className="font-medium">{r.title}</p>
              <p className="text-[11px] text-zinc-500 font-mono">{(r.created_at || '').slice(0, 16).replace('T', ' ')} · {(r.size / 1024).toFixed(0)} KB{r.emailed?.length ? ` · στάλθηκε ${r.emailed.length}×` : ''}</p>
            </div>
            <Button size="sm" variant="outline" className="rounded-none" disabled={busy === r.report_id} onClick={() => download(r)} data-testid={`audit-report-download-${r.report_id}`}>Λήψη Excel</Button>
            <Button size="sm" variant="outline" className="rounded-none" disabled={busy === r.report_id} onClick={() => email(r)} data-testid={`audit-report-email-${r.report_id}`}><EnvelopeSimple size={14} className="mr-1" />Email</Button>
          </div>
        ))}
      </div>
    </div>
  );
};
